import { stringify } from 'query-string'
import { AxiosRequestConfig } from 'axios'

import Base from './base'
import { Query, Template, PublicTemplate } from '../types/template'
import { Metadata } from '../types/filters'
import { EmbeddedResource } from '../types/resource'
import { withAutoCancellation } from '../services/request'

type EmailTemplatesResponse = {
  data: PublicTemplate[]
  metadata: Metadata
}

export default class Templates extends Base {
  async getEmailTemplates(
    query: Query = {},
    config?: AxiosRequestConfig
  ): Promise<EmailTemplatesResponse> {
    return this.api.get(`email_templates?${stringify(query, { arrayFormat: 'bracket' })}`, config)
  }

  getAllEmailTemplates = withAutoCancellation<PublicTemplate[], Query>(async (query, config?) => {
    const finalQuery = {
      per_page: 25,
      filter_by_owner: true,
      include_archived_templates: false,
      include_cadence_templates: false,
      ...query,
      page: 1,
    }
    const { data, metadata } = await this.getEmailTemplates(
      {
        ...finalQuery,
        include_paging_counts: true,
      },
      config
    )

    const totalPages = metadata.paging.total_pages || 1

    if (totalPages < 2) {
      return data
    }

    const requests = []
    for (let page = 2; page <= totalPages; page += 1) {
      requests.push(this.getEmailTemplates({ ...finalQuery, page }, config))
    }

    const responses = await Promise.all(requests)
    const results =
      responses?.reduce<Template<EmbeddedResource>[]>(
        (result, response) => [...result, ...response.data],
        []
      ) || []

    return data.concat(results)
  })
}
